export function MascaraTelefone(value) {
    if (!value) return "";

    // Remove tudo que não é número
    value = String(value).replace(/\D/g, "");

    // Limita a 11 dígitos (DDD + celular com 9 dígitos)
    if (value.length > 11) value = value.slice(0, 11);

    // Aplica a máscara: (XX) XXXX-XXXX ou (XX) XXXXX-XXXX
    if (value.length <= 2) {
        return value.replace(/^(\d{0,2})$/, "($1");
    }

    if (value.length <= 6) {
        return value.replace(/^(\d{2})(\d+)$/, "($1) $2");
    }

    if (value.length === 11) {
        return value.replace(/^(\d{2})(\d{5})(\d{4})$/, "($1) $2-$3");
    }

    return value.replace(/^(\d{2})(\d{4})(\d{0,4})$/, "($1) $2-$3");
}
